import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  processRefundRequest,
  completeRefundRequest,
  getRefundDetail
} from '../../api/sportaloka-client';
import {
  getRefundHistoryContent,
  getStatusColor,
  getStatusLabel,
  getWithdrawStatusColor,
  getWithdrawStatusLabel
} from '../../helpers/status';
import { format } from 'date-fns';
import RefundHistory from './components/RefundHistory';
import RejectRefundModal from './components/RejectRefundModal';
import Swal from 'sweetalert2';

const RefundDetail = () => {
  const { id } = useParams();
  const [initLoading, setInitLoading] = useState();
  const [initError, setInitError] = useState();
  const [data, setData] = useState(null);
  const [selectedTab, setSelectedTab] = useState('refund');
  const [histories, setHistories] = useState([]);

  const getData = async () => {
    try {
      setInitError(false);
      setInitLoading(true);
      const response = await getRefundDetail(id);
      const responseData = response.data.data;
      const refundHistories = responseData.logs.map((item) => getRefundHistoryContent(item));
      setData(responseData);
      setHistories(refundHistories);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  const handleProcess = () => {
    Swal.fire({
      title: 'Apakah anda yakin ingin memproses permintaan ini?',
      text: 'Pastikan anda sudah yakin dengan aksi ini.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, saya yakin!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setInitLoading(true);
          await processRefundRequest(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data berhasil di proses.',
            icon: 'success'
          });
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setInitLoading(false);
        }
      }
    });
  };

  const handleComplete = () => {
    Swal.fire({
      title: 'Apakah anda yakin menyelesaikan permintaan ini?',
      text: 'Pastikan dana telah di transfer ke rekening yang diajukan.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, saya yakin!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setInitLoading(true);
          await completeRefundRequest(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data berhasil di selesaikan.',
            icon: 'success'
          });
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setInitLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Detail Pengembalian Dana</h1>
          <div className="d-flex">
            <Link to="/refund" className="button -sm px-3 bg-white h-50 text-dark">
              <i className="fa fa-arrow-left mr-10" />
              Kembali
            </Link>
            {data && data.status === 'NEW' && (
              <div>
                <button
                  disabled={initLoading}
                  onClick={handleProcess}
                  className="button -sm px-3 bg-blue-1 h-50 text-white ml-20">
                  <i className="fa fa-check mr-10" />
                  Proses Refund
                </button>
              </div>
            )}

            {data && (data.status === 'PROCESS' || data.status === 'NEW') && (
              <div>
                <button
                  disabled={initLoading}
                  className="button -sm px-3 bg-danger h-50 text-white ml-20"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal">
                  <i className="fa fa-close mr-10" />
                  Tolak Permintaan
                </button>
                <RejectRefundModal onFetchData={getData} />
              </div>
            )}

            {data && data.status === 'PROCESS' && (
              <button
                onClick={handleComplete}
                disabled={initLoading}
                className="button -sm px-3 bg-blue-1 h-50 text-white ml-20">
                <i className="fa fa-check mr-10" />
                Selesaikan
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <RefundHistory
              data={histories}
              initLoading={initLoading}
              initError={initError}
              retry={getData}
            />
          </div>
          <div className="col-9">
            <div
              className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20"
              style={{ minHeight: 540 }}>
              {initLoading && !initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100"
                  style={{ minHeight: 540 }}>
                  <div className="loader" />
                  <div className="fw-600" style={{ marginLeft: 12 }}>
                    Loading...
                  </div>
                </div>
              )}
              {!initLoading && initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100 text-center"
                  style={{ minHeight: 540 }}>
                  <p className="fw-600">
                    Gagal! Periksa koneksi internet anda dan{' '}
                    <span className="text-danger cursor-pointer" onClick={getData}>
                      Coba lagi
                    </span>
                  </p>
                </div>
              )}
              {!initLoading && !initError && (
                <div>
                  <div className="custom-tabs">
                    <div
                      className={selectedTab === 'refund' ? 'active' : ''}
                      onClick={() => setSelectedTab('refund')}>
                      Pengajuan
                    </div>
                    <div
                      className={selectedTab === 'order' ? 'active' : ''}
                      onClick={() => setSelectedTab('order')}>
                      Pesanan
                    </div>
                    <div
                      className={selectedTab === 'orderer' ? 'active' : ''}
                      onClick={() => setSelectedTab('orderer')}>
                      Pemesan
                    </div>
                    <div
                      className={selectedTab === 'guests' ? 'active' : ''}
                      onClick={() => setSelectedTab('guests')}>
                      Tamu
                    </div>
                  </div>

                  {selectedTab === 'refund' && (
                    <div>
                      <h5 className="fw-700 text-blue-1 text-18">Informasi Pengajuan</h5>
                      <table className="table table-striped mt-20">
                        <tbody>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Tanggal
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && format(new Date(data.created_at), 'dd/MM/yyyy HH:MM:ss')}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Alasan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.reason}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Update Terakhir
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && format(new Date(data.updated_at), 'dd/MM/yyyy HH:MM:ss')}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Jumlah Dana
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              IDR {data && data.total_price.toLocaleString('id-ID')}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Rekening Bank
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.bank
                                ? `${data.bank.bank_name} ${data.bank.account_number} a/n ${data.bank.account_name}`
                                : '-'}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Status
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              <span
                                className={`px-2 py-1 rounded-1 fw-600 ${data && getWithdrawStatusColor(data.status)}`}>
                                {data && getWithdrawStatusLabel(data.status)}
                              </span>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  {selectedTab === 'order' && (
                    <div>
                      <h5 className="fw-700 text-blue-1 text-18">Informasi Pesanan</h5>
                      <table className="table table-striped mt-20">
                        <tbody>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Kode Booking
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.booking.booking_code}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Nama Site
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.booking.package.tenant.site_name}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Nama Paket
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.booking.package.name_en}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Tanggal Pemesanan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data &&
                                format(new Date(data.booking.created_at), 'dd/MM/yyyy HH:MM:ss')}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Tanggal Pelaksanaan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {format(
                                new Date(data.booking.booked_for_date),
                                'dd/MM/yyyy HH:MM:ss'
                              )}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Status Pemesanan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              <span
                                className={`px-2 py-1 rounded-1 fw-600 ${data && getStatusColor(data.booking.status)}`}>
                                {data && getStatusLabel(data.booking.status)}
                              </span>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  {selectedTab === 'orderer' && (
                    <div>
                      <h5 className="fw-700 text-blue-1 text-18">Informasi Pemesan</h5>
                      <table className="table table-striped mt-20">
                        <tbody>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Nama Pemesan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.booking.user.fullname}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Email Pemesan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.booking.user.email}
                            </th>
                          </tr>
                          <tr>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="30%">
                              Telepon Pemesan
                            </td>
                            <td
                              className="px-3 py-2"
                              style={{ verticalAlign: 'middle !important' }}
                              width="5%">
                              :
                            </td>
                            <th
                              style={{ verticalAlign: 'middle' }}
                              className="text-right px-3 py-2 text-14">
                              {data && data.booking.user.phone_number}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  {selectedTab === 'guests' && (
                    <div>
                      <h5 className="fw-700 text-blue-1 text-18">Daftar Tamu</h5>
                      <table className="table table-striped mt-20">
                        <thead>
                          <tr>
                            <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                              Nama Lengkap
                            </th>
                            <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                              Jenis Tamu
                            </th>
                            <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                              Umur (Tahun)
                            </th>
                            <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                              Berat (Kg)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data &&
                            data.booking.guests.map((guest) => {
                              return (
                                <tr key={guest.id}>
                                  <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                    {guest.fullname}
                                  </td>
                                  <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                    {guest.type === 'LOCAL' ? 'Lokal' : 'Wisman'}
                                  </td>
                                  <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                    {guest.age}
                                  </td>
                                  <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                    {guest.weight}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundDetail;
